import axios from '../../../../utils/request';
function GET_LIST(params) {
    return axios.get("/kshAdmin/ModuleCategory/index",{
        params: {
            page:params
        }
    } )
}
function SUBMIT_ADD(params) {
    return  axios.post("/kshAdmin/ModuleCategory/createPost",{...params} )
}
function EDIT_DATA(params) {
    return  axios.get("/kshAdmin/ModuleCategory/edit",{
        params: {
            ...params
        }
    } )
}
function ADD_DATA(params) {
    return  axios.get("/kshAdmin/ModuleCategory/create",{
        params: {
            ...params
        }
    } )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/kshAdmin/ModuleCategory/editPost",{...params} )
}
function LIST_ORDER(params) {
    return  axios.post("/kshAdmin/ModuleCategory/listOrder",{list_orders:params} )
}
function DELE(params) {
    return  axios.post("/kshAdmin/ModuleCategory/delete",{
            ids:params
    } )
}
function CHANG_STATUS_FILALE(params) {
    return  axios.post("/kshAdmin/ModuleCategory/statusEdit",{
        status: {
            ...params
        }
    } )
}
export default {
    GET_LIST,
    SUBMIT_ADD,
    EDIT_DATA,
    ADD_DATA,
    SUBMIT_EDIT,
    LIST_ORDER,
    DELE,
    CHANG_STATUS_FILALE
};